import React, { useContext, useEffect } from "react";
import { Outlet } from "react-router";

import { AuthContext } from "../context/auth-context";
import BrandAuditDiscoveryProvider from "./BrandAudit/discovery-context";
import BuyingJourneyProvider from "./BuyingJourney/buying-journey-context";
import DiscoveryProvider from "./Discovery/discovery-context";
import DiscoveryProviderV2 from "./DiscoveryV2/discovery-context";
import CategoryAnalysisProvider from "./CategoryAnalysis/category-analysis-context";
import Layout from "./Layout";

const ContentLayout = () => {
  const authCtx = useContext(AuthContext);

  useEffect(() => {
    if (!authCtx.token) return;

    const tokenExpiration = localStorage.getItem("expiration");
    const now = new Date();
    const tokenDuration = new Date(tokenExpiration).getTime() - now.getTime();

    if (tokenDuration < 0) {
      //authCtx.clearSession();
      return;
    }

    setTimeout(() => {
      //authCtx.clearSession();
    }, tokenDuration);
  }, [authCtx.token]);

  return (
    <BuyingJourneyProvider>
      <DiscoveryProvider>
        <DiscoveryProviderV2>
          <BrandAuditDiscoveryProvider>
            <CategoryAnalysisProvider>
              <Layout>
                <Outlet key={authCtx.selectedCustomerId} />
              </Layout>
            </CategoryAnalysisProvider>
          </BrandAuditDiscoveryProvider>
        </DiscoveryProviderV2>
      </DiscoveryProvider>
    </BuyingJourneyProvider>
  );
};

export default ContentLayout;
